import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(() => ({
  tableContainer: {
    maxHeight: '70vh',
    height: 'auto',
  },
}));
